import {termsOfUseState} from '../state/termsOfuseState';
import {    Fetch_TermsOfUse_Success_Data, 
            Update_TermsOfUse_Success,
            Fetch_Terms_Setting_Request } from '../action/termsOfuseAction';

export function TermsOfUseReducer(state = termsOfUseState, action) {
    switch (action.type) {

        case Fetch_TermsOfUse_Success_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                termsConditionSetting : action.termsConditionSetting
            })
        case Update_TermsOfUse_Success:
            return Object.assign({}, state , {
                statusCode : action.statuscode,
                updatedValue : action.value
            })
        case Fetch_Terms_Setting_Request:
            return Object.assign({}, state, {
                statusCode : 0,
                updatedValue : ''
            })
        default : 
            return state
    }
}
